import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import { toast } from "react-toastify";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { wait } from "@testing-library/user-event/dist/utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function PaidClaimActvationHistory() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [dataOutput, setdataOutput] = useState([]);
  const [connected, setconnected] = useState(
    "Wallet is not connected..!..Wait..."
  );

  const [Uid, setUid] = useState(null);
  const [uplineId, setuplineId] = useState(null);
  const [fdate, setfdate] = useState("");
  const [Tdate, setTdate] = useState("");

  let mainAccount = "";

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/PaidActvationClaimList",
        {
          loginid: userId,
          uid: Uid || 0,
          // uplineid: uplineId || 0,
            Fdate: fdate,
          Tdate: Tdate,
          type:2

        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.clear();
      console.log("responceRight?.data?.data-->", responceRight?.data?.data);
      setdataOutput(responceRight?.data.dataOut);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let array = [];
      responceRight.forEach((item, index) => {
        array.push({
          sr: index + 1,
          id: item.id,
          user_id: `${item?.uid} `,
          wallet: item.wallet,
          ClaimedDate: item.dd,
          Claimedstatus: item.Claimedstatus,
          paidstatus: item.paidstatus,
          ClaimDays: item.ClaimDays,
          Amount: item?.amount,
          dd: item?.dd,
          PaidDate: item.paid_date,
          // txn: (
          //   <>
          //     <a
          //       href={`https://bscscan.com/tx/${item.txn}`}
          //       target="_blank">
          //       {" "}
          //       View TXN
          //     </a>
          //   </>
          // ),
        });
        setleftreferralApi(array);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/PaidActvationClaimList",
        {
          loginid: userId,
          uid: Uid || 0,
          uplineid: uplineId || 0,
          Fdate: fdate,
          Tdate: Tdate,
          status:2
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRight = responceRight?.data?.data?.[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          SrNo: index + 1,
          user_id: `${item?.uid} `,
          walletAddress: item.wallet,
          // ClaimDays: item.ClaimDays,
          Amount: item?.amount,
          dd: item?.dd,
          Claimedstatus: item.Claimedstatus,
          paidstatus: item.paidstatus,
          PaidDate: item.paid_date,
        });
      });

      const fileName = "PaidclaimWithdrawalhistory";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "wallet Address", accessor: "wallet" },
      { Header: "Amount", accessor: "Amount" },
      // { Header: "Plan Days", accessor: "ClaimDays" },
      // { Header: "Activation Date", accessor: "dd" },
      // { Header: "Claimedstatus", accessor: "Claimedstatus" },
      { Header: "ClaimedDate", accessor: "ClaimedDate" },
      { Header: "Paid Status", accessor: "paidstatus" },
      { Header: "Paid Date", accessor: "PaidDate" },
     
    ],
  });
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Paid Claim Withdrawal History</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={Uid}
                        onChange={(e) => setUid(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={6}
                      />
                    </div>
                    {/* <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={uplineId}
                        onChange={(e) => setuplineId(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UplineId"
                        maxLength={6}
                      />
                    </div> */}
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setfdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTdate(e.target.value)}
                        id="Tdate"
                        name="Tdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API_Export();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 ">
                      <p>
                        {/* Total Requested Amount (USDT) : {dataOutput?.TotalUsd}
                        <br /> */}
                        Total Amount :{dataOutput?.TotalWithdrawlUsd}
                      </p>{" "}
                    </div>
                  </div>
                  {isLoading ? (
                    <Spinner />
                  ) : (
                    <div className="col-md-12">
                      <Table data={currentPostleft} columns={my_team.cols} />

                      <Table_Buttons
                        indexOfFirstPage={indexOfFirstPage}
                        indexOfLastPost={indexOfLastPost}
                        setcurrentPage={setcurrentPage}
                        currentPage={currentPage}
                        totalData={leftreferralApi.length}
                        listPerpage={listPerpage}
                        handleRowsPerPageChange={setlistPerpage}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaidClaimActvationHistory;
